export default __webpack_public_path__ + "static/media/image.arona-digital.305359a1.png";